// pack-manifest-store.ts
//
// v3: Pack tải qua tarball Supabase (không còn git submodule) → metadata version
// không đọc từ git tag được nữa. Thay bằng file manifest ghi sau khi extract.
//
// Manifest sống tại `.claude/pack/.avatar-pack-manifest.json`:
//   { version, downloadedObject, sha256?, extractedAt }
//
// Đọc version ưu tiên manifest; fallback `.pack-version` (file kèm trong tarball
// do script release ghi) nếu manifest thiếu (vd pack cài tay).
//
// #292: tên file + hình dạng + phép parse chuyển sang `pack-manifest-contract.ts`
// (thuần, không IO) để extension VSCode dùng lại được qua `@nalvietnam/avatar-cli/core`.
// File này chỉ còn là lớp vỏ IO bất đồng bộ.
import { join } from "node:path";
import { pathExists, readText, writeJsonAtomic } from "./filesystem-helpers.js";
import {
  PACK_MANIFEST_FILENAME,
  PACK_VERSION_FILENAME,
  type PackManifest,
  type ParsedPackManifest,
  parsePackManifest,
} from "./pack-manifest-contract.js";

export {
  PACK_MANIFEST_FILENAME,
  PACK_VERSION_FILENAME,
  type PackManifest,
  type ParsedPackManifest,
} from "./pack-manifest-contract.js";

function manifestPath(packDir: string): string {
  return join(packDir, PACK_MANIFEST_FILENAME);
}

export async function writePackManifest(packDir: string, data: PackManifest): Promise<void> {
  await writeJsonAtomic(manifestPath(packDir), data);
}

export async function readPackManifest(packDir: string): Promise<ParsedPackManifest | null> {
  const p = manifestPath(packDir);
  if (!(await pathExists(p))) return null;
  try {
    return parsePackManifest(await readText(p));
  } catch {
    return null;
  }
}

// Đọc version pack đang cài. Ưu tiên manifest → fallback .pack-version → null.
export async function readPackVersionFromFile(packDir: string): Promise<string | null> {
  const manifest = await readPackManifest(packDir);
  if (manifest?.version) return manifest.version;

  const versionFile = join(packDir, PACK_VERSION_FILENAME);
  if (await pathExists(versionFile)) {
    const v = (await readText(versionFile)).trim();
    if (v) return v;
  }
  return null;
}
